<!-- <p>assets works!</p> -->
<!-- <nav class="navbar navbar-expand-lg" id="assetCount">
	<div class="alignRow">
		<mat-icon style="margin-right: 0.2em; cursor: pointer;" (click)="getWatchList()">refresh</mat-icon>
		<span>Watched Assets: </span>
		<span *ngIf="watchedAssets">{{watchedAssets.length}}</span> -->
<!-- <a class="navbar-brand">|</a> -->
<!-- </div>
</nav> -->

<div class="main-watch-div">
	<!-- <nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);"> -->
	<!-- <mat-icon style="margin-right: 0.2em; cursor: pointer;" (click)="getWatchList()">refresh</mat-icon> -->
	<div style="display: flex;" class="alignRow">
		<span style="font-size: large; font-weight: bolder;">Watched Assets:&nbsp;</span>
		<span style="font-size: large; font-weight: bolder;" *ngIf="watchedAssets">{{watchedAssets.length}}</span>
		<span class="toolbar-spacer"></span>
		<mat-icon style="cursor: pointer;" *ngIf="selectedLocation"
			(click)="filterByLocation($event, true)">close</mat-icon>
		<div class="location-dropdown">
			<ejs-dropdownlist id="dropdown" #dropdown [dataSource]='MainLocations' placeholder="Select Location"
				[fields]="locationFields" (change)="filterByLocation($event)" [allowFiltering]="true"
				filterType="contains">
				<ng-template #itemTemplate let-data>
					<div>
						<span>{{ data.Name }}</span>
					</div>
				</ng-template>
			</ejs-dropdownlist>
		</div>
	</div>
	<!-- </nav> -->

	<!-- height="calc(100% - var(--navBar-Height))" -->
	<ejs-splitter #horizontal height="85vh" separatorSize=4 width='100%'>
		<e-panes>
			<e-pane size='30%' min='5%'>
				<ng-template #content>
					<div class="tree-container" id="assetList" style="height: 100%; width: 100%; overflow-y: auto;">
						<!-- <ng-container *ngIf="assets.length > 0; then assettableExpand"> </ng-container> -->
						<ng-container *ngIf="assets.length > 0; then ejsgrid"> </ng-container>
						<!-- <ng-container *ngIf="assets.length > 0; then ejsgrid2"> </ng-container> -->
					</div>
				</ng-template>
			</e-pane>
			<e-pane size='70%' min='5%'>
				<ng-template #content>
					<router-outlet></router-outlet>
				</ng-template>
			</e-pane>
		</e-panes>
	</ejs-splitter>
</div>
<!-- <ng-template #ejsgrid2>
	<ejs-grid #grid2 [dataSource]="dataSource" height=200 (rowSelected)="rowSelected($event)"
		[selectionSettings]="selectionOptions">
		<e-columns>
			<e-column field="Image" headerText="" width="60" textAlign="left"></e-column>
			<e-column field="Name" headerText="Asset Details" textAlign="Left"></e-column>
		</e-columns>
		<ng-template #rowTemplate let-data>
			<tr (click)="trRowSelected(data)" style="padding:0px;margin: 0px;">
				<td class="rowphoto">
					<img src="{{data.ImageURL}}" alt="{{data.Name}}"
						style="height: 50px;max-width: 50px;margin-left: 10px;"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						[attr.x-contenttype]="'image/png'" />
				</td>
				<td class="details">
					<table class="CardTable">
						<colgroup>
							<col width="10px">
							<col width="100%">
						</colgroup>
						<tbody>
							<tr>
								<th>Name:&nbsp;</th>
								<td>{{data.Name}}</td>
							</tr>
							<tr>
								<th>Description:&nbsp;</th>
								<td>{{data.Description}}</td>
							</tr>
						</tbody>
					</table>
				</td>
			</tr>
			<tr>
				<td colspan="2">
					<hr style="padding: 0px;margin: 0px;" />
				</td>
			</tr>
		</ng-template>
	</ejs-grid>
</ng-template> -->
<!-- style="height: calc(99vh - (var(--navBar-Height) + var(--site-navBar-Height))); overflow-y: auto;" -->
<ng-template #ejsgrid>
	<div style="height: 84.5vh;">
		<mat-form-field #filterBar appearance="fill">
			<mat-label>Search For an Asset</mat-label>
			<input matInput autocomplete="off" (keyup)="onFiltering($event)">
		</mat-form-field>
		<ejs-listbox *ngIf="watchedAssets" #listviewInstance [dataSource]='filteredWatchedAssets'
			cssClass='e-list-template' [fields]="fields">
			<ng-template #itemTemplate let-dataSource>
				<div class="alignRow watchedAssetsBox"
					[ngStyle]="{ 'background-color': selectedAsset.AssetID == dataSource.AssetID ? 'whitesmoke' : 'white' }"
					(click)="assetSelected(dataSource)">
					<img class="assetImage" src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource.Modified}}"
						style="max-height: 50px; max-width: 50px;"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						(click)='viewImage(imagePathAssets() + dataSource.AssetID + "?" + dataSource.Modified)'
						[attr.x-contenttype]="'image/png'" />
					<span>{{dataSource.Name}}</span>
					<span>{{dataSource.Description}}</span>
				</div>
			</ng-template>
		</ejs-listbox>
	</div>
	<!-- <ejs-grid #grid [dataSource]="watchedAssets" height="100%" (rowSelected)="rowSelected($event)" [allowPaging]="true"
		[pageSettings]='pageSettings' [selectionSettings]="selectionOptions">
		<e-columns>
			<e-column field="Name" headerText="Name" width="125" textAlign="Left"></e-column>
			<e-column field="Description" headerText="Description" textAlign="Left"></e-column>
		</e-columns>
		<ng-template #detailTemplate let-data>
			<table class="detailtable" cellpadding="3" cellspacing="2">
				<colgroup>
					<col width="60px">
					<col width="25%">
					<col width="100%">
				</colgroup>
				<tbody>
					<tr>
						<td class="rowphoto" rowspan="2">
							<img class="assetImage" src="{{imagePathAssets()}}{{data.AssetID}}?{{data.Modified}}"
								style="max-height: 50px; max-width: 50px;"
								onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
								(click)='viewImage(imagePathAssets() + data.AssetID + "?" + data.Modified)'
								[attr.x-contenttype]="'image/png'" />
						</td>
						<th class="CardHeader">Name:&nbsp;</th>
						<td>{{data.Name}}</td>
					</tr>
					<tr>
						<th class="CardHeader">Description:&nbsp;</th>
						<td>{{data.Description}}</td>
					</tr>
				</tbody>
			</table>
		</ng-template>
	</ejs-grid> -->
</ng-template>

<ng-template #assettableExpand>
	<div class="assetTable" id="assetTable">
		<table mat-table [dataSource]="dataSource" multiTemplateDataRows>
			<!-- Generate a column for defines items -->
			<ng-container matColumnDef="{{column}}" *ngFor="let column of columnsToDisplay">

				<!-- If Column is watch show the Star Icon-->
				<ng-container *ngIf="column == 'Watch'; then watchColumn else textColumn"> </ng-container>

				<!-- Define the contents of the Watch Column -->
				<ng-template #watchColumn>
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let element">
						<mat-icon *ngIf="element[column] == true" style="color: black;"
							ngbTooltip="In Watch List">visibility</mat-icon>
						<mat-icon *ngIf="element[column] == false" style="color: lightgray;">visibility</mat-icon>
					</td>
				</ng-template>

				<!-- Define Regular Text column -->
				<ng-template #textColumn>
					<th mat-header-cell *matHeaderCellDef> {{column}} </th>
					<td mat-cell *matCellDef="let element"> {{element[column]}} </td>
				</ng-template>
			</ng-container>

			<!-- Add a Expand/Colapse drop down -->
			<ng-container matColumnDef="Expanded">
				<th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
				<td mat-cell *matCellDef="let element">
					<button mat-icon-button aria-label="expand row"
						(click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
						<mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
						<mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
					</button>
				</td>
			</ng-container>

			<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
			<ng-container matColumnDef="expandedDetail">
				<td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
					<div class="element-detail" (click)="assetClick(element)"
						[@detailExpand]="element == expandedElement ? 'Expanded' : 'collapsed'">
						<div class="element-diagram">
							<!-- <div class="element-assetID">ID:&nbsp;{{element.AssetID}} </div>
							<div class="element-name"> {{element.Name}} </div>
							<div class="element-type">Type:&nbsp;{{element.Type}} </div> -->
							<img src="{{element.ImageURL}}"
								onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
								[attr.x-contenttype]="'image/png'" />
						</div>
						<div class="element-description" style="display: flex; flex-direction: column;">
							<span>{{element.Description}}</span>
							<span><span style="font-weight: bolder;">Location:</span>Description of Location</span>
							<span><span style="font-weight: bolder;">Open Cases:</span>0</span>
							<span></span>
							<!-- <span class="element-description-attribution"> -- Wikipedia </span> -->
						</div>
					</div>
				</td>
			</ng-container>

			<!-- (click)="expandedElement = expandedElement === element ? null : element" -->
			<tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
			<tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="element-row"
				[class.expanded-row]="expandedElement === element" routerLink="{{element.AssetID}}">
				<!-- (click)="assetClick(element)" -->
			</tr>
			<tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
		</table>
		<mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" pageSize="25"
			aria-label="Select page of users"></mat-paginator>
	</div>
</ng-template>